import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { registerServiceWorker } from "./pwa";
import "./styles.css";
import { ToastProvider } from "./toasts/ToastProvider";
import { AppKitProvider } from "./wallet/AppKitProvider";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Stonkland could not find its root element.");
}

createRoot(root).render(
  <StrictMode>
    <AppKitProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </AppKitProvider>
  </StrictMode>,
);

registerServiceWorker();
